export default {
  wasThisHelpfulWrapper:
    'wasThisHelpfulWrapper flex justify-center items-center py-23 bg-lightGrey',
  wasThisHelpfulText: 'wasThisHelpfulText m-0 mr-35',
  wasThisHelpfulIconWrapper: 'flex',
  thumbsUpIconStyles:
    'thumbs-up-icon mx-15 cursor-pointer w-42 py-12 border-1 border-solid border-black flex justify-center rounded-50p',
  thumbsDownIconStyles:
    'thumbs-down-icon mx-15 cursor-pointer w-42 py-12 border-1 border-solid border-black flex justify-center rounded-50p',
  thumbsUpIconWrapper: 'thumbsUpIconWrapper',
  thumbsUpIconDiv: 'thumbsUpIconWrapper',
  thumbsUpStyles: 'cursor-pointer',
  thumbsDownIconSelected:
    'thumbsDownIconSelected bg-pipeLIneBorder mx-15 cursor-pointer w-42 py-12 border-1 border-solid border-black flex justify-center rounded-50p',
  thumbsUpIconSelected:
    'thumbsUpIconSelected bg-pipeLIneBorder mx-15 cursor-pointer w-42 py-12 border-1 border-solid border-black flex justify-center rounded-50p',
  thumbsUpIconDivSelected:
    'thumbsUpIconDivSelected bg-pipeLIneBorder cursor-pointer w-42 py-12 border-1 border-solid border-black flex justify-center rounded-50p',
  thumbsUpStylesSelected: 'thumbsUpStylesSelected',
  svgWidthHeight: 'w-15 h-15',
};
